import 'milligram';
import '../styles/index.scss';
import { render } from 'inferno';
import App from './App';

render((<App />), document.body);
